<template>
  <div class="privacy-terms-page">
    <div class="page-container">
      <!-- 头部导航 -->
      <div class="page-header">
        <div class="logo-wrapper" @click="$router.push('/')">
          <span class="logo-text">中国品牌网</span>
        </div>
      </div>

      <!-- 页面内容 -->
      <div class="page-content">
        <div class="content-wrapper">
          <!-- 标题 -->
          <h1 class="agreement-title">隐私条款</h1>
          
          <!-- 条款信息 -->
          <div class="agreement-meta">
            <span class="meta-item">条款生效日期：2026 年 9 月 15 日</span>
            <span class="meta-item">最后更新日期：2026 年 9 月 15 日</span>
          </div>

          <!-- 特别提示 -->
          <div class="special-highlight">
            <strong>【特别提示】</strong> 
            中国品牌网（以下简称"本平台"或"我们"，由《中国品牌》杂志社有限责任公司运营）非常重视您的个人 (企业) 信息保护。本《隐私条款》将帮助您了解我们如何收集、使用、存储、共享、保护及处理您的个人 (企业) 信息，以及您所享有的相关权利和行使方式。请您在使用我们的服务前，仔细阅读并透彻理解本《隐私条款》，在确认充分理解并同意后再开始使用。您使用或继续使用我们的服务，即表示您同意我们按照本《隐私条款》处理您的相关信息。
          </div>

          <!-- 平台运营信息 -->
          <div class="platform-info">
            本平台由《中国品牌》杂志社有限责任公司（以下简称"我们"）运营，主办单位为中国品牌建设促进会，主管单位为国家市场监督管理总局。本《隐私条款》构成《用户协议》不可分割的组成部分。
          </div>

          <!-- 条款正文 -->
          <div class="terms-content">
            <!-- 一、本《隐私条款》的适用范围 -->
            <section class="terms-section">
              <h2>一、本《隐私条款》的适用范围</h2>
              <div class="section-content">
                <p><strong>1.1</strong>本《隐私条款》适用于您在使用本平台服务（包括但不限于品牌资讯浏览、品牌影响力指数查询、品牌活动报名、战略合作伙伴项目参与、品牌扶摇计划公益项目参与、广告及营销服务、注册账号等）过程中，我们对您个人 (企业) 信息的收集、使用、存储、共享、转让、公开披露等活动。</p>
                <p><strong>1.2</strong>本《隐私条款》不适用于通过本平台接入的、由第三方独立运营的网站、应用程序、产品或服务（包括但不限于我们融媒集群所入驻的第三方平台、第三方广告主网站、第三方链接等）。当您跳转到第三方平台时，请您仔细阅读该等第三方平台独立的隐私政策。</p>
              </div>
            </section>

            <!-- 二、我们如何收集和使用您的个人 (企业) 信息 -->
            <section class="terms-section">
              <h2>二、我们如何收集和使用您的个人 (企业) 信息</h2>
              <div class="section-content">
                <p><strong>2.1 我们收集的个人 (企业) 信息类型</strong></p>
                <p>为向您提供稳定、安全、优质的服务，我们可能会在以下场景中收集您的个人 (企业) 信息：</p>
                
                <p><strong>（一）注册、登录与账号管理</strong></p>
                <p>当您注册或登录本平台账号时，我们会收集您的手机号码、电子邮箱、用户名、密码（加密存储）、头像、昵称、所在地区等信息，用于账号创建与身份验证。</p>
                
                <p><strong>（二）使用本平台服务过程中</strong></p>
                <p>当您使用本平台品牌资讯、品牌影响力指数查询、评论互动、品牌活动报名、合作申请等具体服务时，我们可能会收集您的浏览记录、搜索记录、点击记录、收藏记录、评论内容、互动记录、设备信息（设备型号、操作系统版本、设备识别码）、日志信息（IP 地址、访问时间、访问页面、停留时长、网络环境）、Cookie 与同类技术信息等。</p>
                
                <p><strong>（三）参加品牌活动或合作项目</strong></p>
                <p>当您报名参加本平台主办或协办的会议、论坛、调研、培训、沙龙、公益项目，或申请成为"中国品牌战略合作伙伴"、"中国品牌观察员"、"中国品牌理论创新工程"等项目参与方时，我们会收集您的姓名、单位、职务、联系方式、身份证件信息（仅在必要场景）、合作需求、案例素材等。</p>
                
                <p><strong>（四）广告与营销服务</strong></p>
                <p>当您通过本平台购买或咨询广告发布、营销策划、企业形象策划、展览展示、会议服务、技术推广等服务时，我们会收集您的单位信息、联系人信息、银行账户或发票信息等。</p>
                
                <p><strong>（五）客户服务与投诉处理</strong></p>
                <p>当您与我们联系、提出咨询、意见、建议或投诉时，为便于联系和解决问题，我们可能会保存您的姓名、联系方式、问题描述、沟通记录等。</p>
                
                <p><strong>（六）保障账号与服务安全</strong></p>
                <p>为保障您的账号安全、识别异常登录、防范安全风险、识别违法违规行为，我们会收集设备信息、日志信息、位置信息（经您授权时）、生物识别信息（经您单独授权时）等。</p>

                <p><strong>2.2 我们使用个人 (企业) 信息的目的</strong></p>
                <p>我们收集您的个人 (企业) 信息，主要用于以下目的：</p>
                <ol>
                  <li>为您提供本平台各项服务，并维护、改进、优化这些服务；</li>
                  <li>为您注册账号、验证身份、维护账号安全；</li>
                  <li>向您推送您可能感兴趣的品牌资讯、活动通知、合作信息、服务推荐等；</li>
                  <li>开展品牌影响力评价、品牌研究、行业报告编制等学术研究工作；</li>
                  <li>开展市场调研、客户满意度调查、品牌运营分析；</li>
                  <li>响应您的咨询、意见、建议与投诉，提供客户服务；</li>
                  <li>履行法律法规规定的义务，配合主管部门的监管要求；</li>
                  <li>防范安全风险，识别、阻止欺诈、违法违规行为；</li>
                  <li>经您授权或同意的其他用途。</li>
                </ol>

                <p><strong>2.3 依法不需要取得您同意的例外</strong></p>
                <p>根据相关法律法规，以下情形中我们收集、使用您的个人 (企业) 信息无需征得您的同意：</p>
                <ol>
                  <li>为订立、履行您与我们之间合同所必需的；</li>
                  <li>为履行法定职责或法定义务所必需的；</li>
                  <li>为应对突发公共卫生事件，或者紧急情况下为保护您或其他人的生命健康、财产安全所必需的；</li>
                  <li>在合理范围内收集您自行向社会公众公开的或者其他已经合法公开的个人 (企业) 信息；</li>
                  <li>法律法规规定的其他情形。</li>
                </ol>
              </div>
            </section>

            <!-- 三、我们如何使用 Cookie 与同类技术 -->
            <section class="terms-section">
              <h2>三、我们如何使用 Cookie 与同类技术</h2>
              <div class="section-content">
                <p><strong>3.1</strong>Cookie 是由浏览器存储在您的计算机或移动设备上的小型文本文件，包含您访问网站时由网站发送至您设备上的少量信息。我们使用 Cookie 及同类技术（包括 Web Beacon、Local Storage、Session Storage 等）来记住您的身份、了解您的使用偏好、提升您的访问体验。</p>
                
                <p><strong>3.2 我们使用的 Cookie 主要包括以下类型：</strong></p>
                <ol>
                  <li><strong>必要 Cookie</strong>：用于识别您是否已登录、维持您的登录状态、保障账号与服务安全。该等 Cookie 是提供本平台基础服务所必需的，您无法通过关闭 Cookie 来避免其使用。</li>
                  <li><strong>偏好 Cookie</strong>：用于记住您的偏好设置（如语言、地区、字号等），为您提供更个性化的服务。</li>
                  <li><strong>统计 Cookie</strong>：用于统计本平台访问量、用户使用习惯、流量来源、页面停留时长等运营数据，以帮助我们改进产品与服务。</li>
                  <li><strong>营销 Cookie</strong>：用于在本平台或其他第三方平台向您展示更相关的广告内容。</li>
                </ol>
                
                <p><strong>3.3</strong>您可以通过浏览器设置、隐私设置或本平台提供的偏好设置来管理或删除 Cookie。请您注意，如果您选择拒绝或删除部分 Cookie，您可能无法使用本平台依赖于该等 Cookie 的部分服务或功能。</p>
              </div>
            </section>

            <!-- 四、我们如何共享、转让、公开披露您的个人 (企业) 信息 -->
            <section class="terms-section">
              <h2>四、我们如何共享、转让、公开披露您的个人 (企业) 信息</h2>
              <div class="section-content">
                <p><strong>4.1 共享</strong></p>
                <p>我们承诺不会主动与任何第三方共享您的个人 (企业) 信息，但以下情形除外：</p>
                <ol>
                  <li><strong>事先获得您的明确同意或授权：</strong>在获得您的明确同意后，我们会与其他方共享您的个人 (企业) 信息。</li>
                  <li><strong>与我们的关联实体共享：</strong>基于本平台融媒集群需要，我们可能会与《中国品牌》杂志社有限责任公司及其分支机构、下属融媒账号、关联研究中心共享您的个人 (企业) 信息，以为您提供一致化的服务。</li>
                  <li><strong>与业务合作伙伴共享：</strong>当您申请或参与由我们与合作机构（如战略合作伙伴、品牌扶摇计划公益项目合作机构、品牌研究合作机构）共同举办的活动时，我们可能会与合作机构共享必要的报名信息、合作需求等。</li>
                  <li><strong>与广告主或营销服务对象共享：</strong>基于业务合作需要，我们可能向合法授权的广告主、营销服务对象提供去标识化或匿名化处理后的统计数据。</li>
                  <li><strong>委托处理：</strong>我们可能会委托具备合法资质的第三方服务商（如技术服务方、托管服务方、客服外包方、短信与邮件发送服务商、数据分析服务商）处理您的个人 (企业) 信息，我们会对受托方进行严格的资质审核与监督，并要求其按照我们的要求、本《隐私条款》以及法律法规的规定处理您的个人 (企业) 信息。</li>
                  <li><strong>法定情形下的共享：</strong>根据法律法规规定、诉讼争议解决需要、或政府主管部门依法要求，我们可能会对外共享您的个人 (企业) 信息。</li>
                </ol>

                <p><strong>4.2 转让</strong></p>
                <p>我们不会主动将您的个人 (企业) 信息转让给任何第三方，但以下情形除外：</p>
                <ol>
                  <li>事先获得您的明确同意；</li>
                  <li>在本平台运营主体发生合并、分立、收购、资产转让等情形时，如涉及个人 (企业) 信息转让，我们会要求新的持有您个人 (企业) 信息的公司、组织继续受本《隐私条款》约束，否则我们将要求其重新取得您的同意。</li>
                </ol>

                <p><strong>4.3 公开披露</strong></p>
                <p>我们原则上不会公开披露您的个人 (企业) 信息，但以下情形除外：</p>
                <ol>
                  <li>事先获得您的明确同意；</li>
                  <li>基于法律法规或主管部门强制要求。</li>
                </ol>

                <p><strong>4.4 共享、转让、公开披露时的特别提示</strong></p>
                <p>请您知悉，根据法律法规规定，以下情形中我们共享、转让、公开披露您的个人 (企业) 信息无需事先征得您的同意：</p>
                <ol>
                  <li>为订立、履行您与我们之间合同所必需的；</li>
                  <li>为履行法定职责或法定义务所必需的；</li>
                  <li>为应对突发公共卫生事件，或者紧急情况下为保护您或其他人的生命健康、财产安全所必需的；</li>
                  <li>在合理范围内收集您自行向社会公众公开的或者其他已经合法公开的个人 (企业) 信息；</li>
                  <li>法律法规规定的其他情形。</li>
                </ol>
              </div>
            </section>

            <!-- 五、我们如何存储和保护您的个人 (企业) 信息 -->
            <section class="terms-section">
              <h2>五、我们如何存储和保护您的个人 (企业) 信息</h2>
              <div class="section-content">
                <p><strong>5.1 存储地点</strong></p>
                <p>我们在中华人民共和国境内运营中收集和产生的个人 (企业) 信息，将存储在中华人民共和国境内。如未来因业务需要，部分个人 (企业) 信息需出境，我们将严格遵守法律法规关于个人 (企业) 信息出境的要求，并单独向您告知出境的目的、类型、接收方、安全保障措施等情况，并征得您的同意。</p>
                
                <p><strong>5.2 存储期限</strong></p>
                <p>我们仅在为您提供本平台服务所必需的最短期间内保留您的个人 (企业) 信息，超出该期限后，我们将对您的个人 (企业) 信息进行删除或匿名化处理，但法律法规另有规定的除外。例如：</p>
                <ol>
                  <li><strong>注册账号信息：</strong>在您使用本平台服务期间持续保存；账号注销后，除法律法规要求保留的少量信息外，我们将予以删除。</li>
                  <li><strong>浏览、搜索等日志信息：</strong>原则上保留不超过 6 个月，法律法规另有规定的除外。</li>
                  <li><strong>品牌活动报名与项目合作信息：</strong>根据具体项目要求及法律法规规定的会计、税务、审计期限予以保留。</li>
                </ol>

                <p><strong>5.3 安全保护措施</strong></p>
                <p>我们采用符合业界标准的安全技术和组织措施来保护您的个人 (企业) 信息，防止个人 (企业) 信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失，包括但不限于：</p>
                <ol>
                  <li><strong>加密传输：</strong>使用 SSL/TLS 等加密协议保障数据传输安全。</li>
                  <li><strong>分级存储与访问控制：</strong>对个人 (企业) 信息进行分级分类管理，严格限制可访问人员范围，并对访问行为进行审计。</li>
                  <li><strong>身份认证：</strong>对涉及个人信息的内部操作要求身份认证与权限审批。</li>
                  <li><strong>安全审计与渗透测试：</strong>定期开展安全审计、漏洞扫描与渗透测试，及时修复安全漏洞。</li>
                  <li><strong>应急预案：</strong>建立个人信息安全事件应急响应机制，定期组织应急演练。</li>
                  <li><strong>人员管理：</strong>与接触个人信息的人员签署保密协议，开展个人信息保护培训。</li>
                </ol>

                <p><strong>5.4 安全事件处置</strong></p>
                <p>尽管我们采取了上述合理有效的安全措施，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业不存在绝对的安全。如不幸发生个人 (企业) 信息安全事件，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况、可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、我们的联系方式等。我们将及时通过页面公告、短信、邮件等方式告知您，难以逐一告知的，我们将通过本平台公告的方式发布警示信息。</p>
              </div>
            </section>

            <!-- 六、您的权利 -->
            <section class="terms-section">
              <h2>六、您的权利</h2>
              <div class="section-content">
                <p>按照中华人民共和国相关法律法规，您对您的个人 (企业) 信息享有以下权利，我们承诺将为您提供便捷、有效的权利行使途径：</p>

                <p><strong>6.1 查询、复制权</strong></p>
                <p>您有权查询、复制您的个人 (企业) 信息。您可以通过本平台提供的功能页面或通过本《隐私条款》公布的联系方式向我们提出请求，我们将在 15 个工作日内予以回复。</p>

                <p><strong>6.2 更正、补充权</strong></p>
                <p>如您发现我们收集、存储的您的个人 (企业) 信息有错误或不完整的，您有权向我们提出更正或补充请求，我们将在核实您的身份后及时予以更正或补充。</p>

                <p><strong>6.3 删除权</strong></p>
                <p>在以下情形中，您有权向我们提出删除个人 (企业) 信息的请求：</p>
                <ol>
                  <li>处理目的已实现、无法实现或为实现处理目的不再必要；</li>
                  <li>我们停止提供产品或服务，或者保存期限已届满；</li>
                  <li>您撤回同意；</li>
                  <li>我们违反法律法规或与您的约定处理您的个人 (企业) 信息；</li>
                  <li>法律法规规定的其他情形。</li>
                </ol>

                <p><strong>6.4 撤回同意权</strong></p>
                <p>对于基于您同意处理的个人信息，您有权随时撤回您的同意。您可以通过本平台功能页面、浏览器设置或通过本《隐私条款》公布的联系方式向我们提出请求。您撤回同意不影响撤回前基于您的同意已经进行的个人信息处理活动的效力。</p>

                <p><strong>6.5 注销账号权</strong></p>
                <p>您有权注销您的注册账号。账号注销后，我们将停止为您提供基于该账号的服务，并按照本《隐私条款》第 5.2 条的约定对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</p>

                <p><strong>6.6 限制处理、反对自动化决策权</strong></p>
                <p>在特定情形下，您有权限制我们处理您的个人信息，或对涉及您的自动化决策（如个性化推荐）提出反对，要求我们予以解释说明并提供替代方案。</p>

                <p><strong>6.7 逝者近亲属权利</strong></p>
                <p>如您是不幸去世的自然人的近亲属，为了其合法、正当利益，您可以代其行使本《隐私条款》项下的查询、复制、更正、删除等权利。</p>

                <p><strong>6.8 响应您的请求</strong></p>
                <p>为保障您的上述权利得到有效行使，我们将在收到您的请求后 15 个工作日内予以核查并回复。如您对我们的回复不满意，或我们对您的请求未予处理的，您有权通过以下途径寻求解决：</p>
                <ol>
                  <li>向国家网信部门、消费者协会、行业自律组织等投诉；</li>
                  <li>向有管辖权的人民法院提起诉讼。</li>
                </ol>
                <p class="note"><strong>特别提示：</strong>为保障您与他人的合法权益，我们可能会要求您提供必要的身份证明材料以验证您的身份。请您理解，基于安全考虑，对于身份证明材料不充分、不准确或无法验证的请求，我们可能会暂缓或拒绝处理。请您知悉，根据法律法规规定，在以下情形中我们可能无法响应您的请求：</p>
                <ol class="note">
                  <li>与我们履行法律法规规定的义务相关的；</li>
                  <li>与国家安全、国防安全直接相关的；</li>
                  <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
                  <li>与犯罪侦查、起诉、审判和判决执行等直接相关的；</li>
                  <li>我们有充分证据表明您存在主观恶意或滥用权利的；</li>
                  <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</li>
                  <li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</li>
                  <li>涉及商业秘密的。</li>
                </ol>
              </div>
            </section>

            <!-- 七、未成年人保护 -->
            <section class="terms-section">
              <h2>七、未成年人保护</h2>
              <div class="section-content">
                <p><strong>7.1</strong>我们非常重视对未成年人的个人 (企业) 信息的保护。我们主要面向品牌行业从业者、企业品牌管理者、市场营销人员、学术研究者、媒体同行等专业用户提供服务，原则上不直接面向 14 周岁以下的未成年人提供服务。</p>
                <p><strong>7.2</strong>如您是 14 周岁以上的未成年人（即"限制民事行为能力人"），在使用本平台服务前，应由您的父母或法定监护人代为阅读本《隐私条款》，并在征得您父母或法定监护人同意的前提下，方可使用本平台服务并向我们提供您的个人 (企业) 信息。</p>
                <p><strong>7.3</strong>如您是不满 14 周岁的儿童，请勿向我们提供您的个人信息。如我们发现未经父母或法定监护人同意而收集了儿童的个人信息，我们将尽快采取删除、匿名化等合理措施。</p>
                <p><strong>7.4</strong>如您是未成年人用户或其监护人，请通过本《隐私条款》公布的联系方式与我们联系，我们将在核实您的身份后尽快处理相关事宜。</p>
              </div>
            </section>

            <!-- 八、第三方服务与第三方链接 -->
            <section class="terms-section">
              <h2>八、第三方服务与第三方链接</h2>
              <div class="section-content">
                <p><strong>8.1</strong>为提供更丰富的服务，本平台可能包含跳转到第三方网站、应用程序或服务的链接（包括但不限于国家企业信用信息公示系统、全国 12315 平台、国家标准全文公开系统、认证机构资质审批系统等政务服务平台，以及人民日报客户端、微博、微信公众号、视频号、抖音号、快手号、今日头条、网易、百度、腾讯等融媒入驻平台）。</p>
                <p><strong>8.2</strong>您通过第三方链接访问第三方平台时，您与第三方之间形成独立的法律关系。该等第三方平台有其独立的隐私政策，我们不对其内容、政策、行为承担任何责任。请您在访问第三方平台前，仔细阅读其隐私政策。</p>
                <p><strong>8.3</strong>本平台可能嵌入由第三方提供的小型组件、SDK、API 等，用于实现特定功能（如地图服务、分享服务、统计服务、客服服务等）。在该等情况下，第三方可能会基于功能实现的需要收集您的部分信息（如 IP 地址、设备信息等）。具体第三方收集与使用情况，请以其各自公布的隐私政策为准。</p>
              </div>
            </section>

            <!-- 九、本《隐私条款》的变更 -->
            <section class="terms-section">
              <h2>九、本《隐私条款》的变更</h2>
              <div class="section-content">
                <p><strong>9.1</strong>我们保留根据法律法规变更、业务调整、技术升级等原因适时修订本《隐私条款》的权利。</p>
                <p><strong>9.2</strong>修订后的《隐私条款》一旦在本平台发布，即代替原《隐私条款》生效。对于重大变更（包括但不限于服务模式重大变化、个人信息处理目的重大变化、第三方共享对象重大变化、个人信息存储期限重大变化、用户权利及其行使方式重大变化等），我们会以页面公告、弹窗提示、邮件通知、短信通知等显著方式告知您。</p>
                <p><strong>9.3</strong>如您不同意修订后的《隐私条款》，您有权停止使用本平台服务；如您继续使用本平台服务，则视为您接受修订后的《隐私条款》。</p>
              </div>
            </section>

            <!-- 十、联系我们 -->
            <section class="terms-section">
              <h2>十、联系我们</h2>
              <div class="section-content">
                <p>如您对本《隐私条款》或您的个人信息保护有任何疑问、意见、建议、投诉，或希望行使您的权利，请通过以下方式与我们联系：</p>
                <p><strong>运营主体：</strong>《中国品牌》杂志社有限责任公司</p>
                <p><strong>统一社会信用代码：</strong>91110106795986730N</p>
                <p><strong>办公地址：</strong>北京市朝阳区北三环东路 18 号院 6 号楼</p>
                <p><strong>联系电话：</strong>010-65283638</p>
                <p><strong>电子邮箱：</strong>bd@cbrand.com.cn</p>
                <p><strong>主管单位：</strong>国家市场监督管理总局</p>
                <p><strong>主办单位：</strong>中国品牌建设促进会</p>
                <p><strong>业务归口：</strong>国家市场监督管理总局新闻宣传司</p>
                <p><strong>期刊信息：</strong>国际标准刊号 ISSN 1673-7741，国内统一刊号 CN 11-5562/T</p>
                <p><strong>ICP 备案：</strong>京 ICP 备 16035947 号</p>
                <p><strong>官方网站：</strong>https://www.cbrand.com.cn</p>
                <p>为保障您的合法权益，我们将在收到您的反馈后 15 个工作日内予以回复处理。如您对我们的回复不满意，或我们对您的请求未予处理，您还可以通过以下途径寻求解决：</p>
                <ol>
                  <li>向国家网信部门、消费者协会、行业自律组织等投诉举报；</li>
                  <li>向有管辖权的人民法院提起诉讼。</li>
                </ol>
              </div>
            </section>

            <!-- 十一、其他 -->
            <section class="terms-section">
              <h2>十一、其他</h2>
              <div class="section-content">
                <p><strong>11.1</strong>本《隐私条款》自您点击同意或开始使用本平台服务之日起生效。</p>
                <p><strong>11.2</strong>本《隐私条款》的订立、执行、解释及争议解决均适用中华人民共和国法律法规（为本《隐私条款》之目的，不包括香港特别行政区、澳门特别行政区和台湾地区的法律）。如本《隐私条款》与《用户协议》就同一事项存在不一致的，以本《隐私条款》为准；如本《隐私条款》未约定的，按《用户协议》执行。</p>
                <p><strong>11.3</strong>本《隐私条款》中所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本《隐私条款》相关条款解释的依据。</p>
                <p><strong>11.4</strong>本《隐私条款》所有条款无论因何种原因部分无效或不可执行，其余条款仍有效，对各方具有约束力。</p>
              </div>
            </section>
          </div>

          <!-- 底部声明 -->
          <div class="terms-footer">
            <p>请您再次确认：您已经仔细阅读、充分理解并接受本《隐私条款》的全部条款，并同意按照本《隐私条款》之约定处理您的个人信息。如您不同意本《隐私条款》的任何条款，请立即停止使用本平台服务。</p>
            <p class="copyright">© 版权所有《中国品牌》杂志社有限责任公司 保留一切权利</p>
          </div>

          <!-- 返回按钮 -->
          <!-- <div class="back-button">
            <button class="btn btn-secondary" @click="$router.back()">返回列表</button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyTerms',
  mounted() {
    // 设置页面标题
    document.title = '隐私条款 - 中国品牌网'
  }
}
</script>

<style scoped>
.privacy-terms-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-container {
  width: 100%;
}

/* 页面头部 */
.page-header {
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 0;
  text-align: center;
}

.logo-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  cursor: pointer;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #B91816;
}

/* 页面内容区域 */
.page-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.content-wrapper {
  padding: 40px;
}

/* 标题样式 */
.agreement-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  border-bottom: 2px solid #B91816;
  padding-bottom: 20px;
}

/* 条款元信息 */
.agreement-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  color: #666;
  font-size: 14px;
}

/* 特别提示 */
.special-highlight {
  background-color: #FFF3CD;
  border-left: 4px solid #FFC107;
  padding: 16px 20px;
  margin-bottom: 24px;
  border-radius: 4px;
  font-size: 14px;
}

.special-highlight strong {
  color: #856404;
}

/* 平台信息 */
.platform-info {
  background-color: #E7F3FF;
  border-left: 4px solid #2196F3;
  padding: 16px 20px;
  margin-bottom: 30px;
  border-radius: 4px;
  color: #0C5460;
  font-size: 14px;
}

/* 条款章节 */
.terms-section {
  margin-bottom: 40px;
  page-break-inside: avoid;
}

.terms-section h2 {
  font-size: 22px;
  color: #B91816;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.section-content {
  color: #333;
  line-height: 1.8;
  font-size: 15px;
}

.section-content p {
  margin-bottom: 12px;
  text-align: justify;
}

.section-content ol {
  margin-left: 24px;
  margin-bottom: 12px;
}

.section-content li {
  margin-bottom: 8px;
}

.note {
  font-size: 14px;
  color: #666;
}

.note ol {
  margin-top: 8px;
}

/* 页脚声明 */
.terms-footer {
  background-color: #f9f9f9;
  border-left: 4px solid #666;
  padding: 20px;
  margin-top: 40px;
  margin-bottom: 40px;
  border-radius: 4px;
  font-size: 14px;
}

.terms-footer p {
  margin-bottom: 12px;
}

.terms-footer .copyright {
  color: #999;
  font-size: 14px;
  margin-top: 20px;
}

/* 返回按钮 */
.back-button {
  text-align: center;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

.btn {
  padding: 12px 32px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid transparent;
}

.btn-secondary {
  background-color: #fff;
  border-color: #ddd;
  color: #666;
}

.btn-secondary:hover {
  background-color: #f5f5f5;
  border-color: #ccc;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-content {
    padding: 20px 10px;
    margin-top: 10px;
  }

  .content-wrapper {
    padding: 20px;
  }

  .agreement-title {
    font-size: 24px;
  }

  .agreement-meta {
    flex-direction: column;
    gap: 10px;
  }

  .section-content {
    font-size: 14px;
  }
}
</style>
